import axios from 'axios';
import ServerProperties from '../config/server.js'

export default {
  ReadReport: function(params) {
    const {
      status, 
      type, 
      owner, 
      site, 
      location, 
      purchaser, 
      start_purchase_date, 
      finish_purchase_date, 
      vendor
    } = params.data.field;

    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      params.data.url === undefined ? 
      ServerProperties.ATM_CLOUD.API+ 'Asset/Info/?status=' + status + 
                                                  '&type=' + type + 
                                                  '&owner=' + owner + 
                                                  '&site=' + site + 
                                                  '&location=' + location + 
                                                  '&purchaser=' + purchaser + 
                                                  '&start_purchase_date=' + start_purchase_date + 
                                                  '&finish_purchase_date=' + finish_purchase_date +
                                                  '&vendor=' + vendor +
                                                  '&ordering=PurchaseCurrency__Name, Name'
      : params.data.url
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
  ReadAssetTotalValue: function(params) {
    const {
      status, 
      type, 
      owner, 
      site, 
      location, 
      purchaser, 
      start_purchase_date, 
      finish_purchase_date, 
      vendor
    } = params.data.field;

    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      params.data.url === undefined ? 
      ServerProperties.ATM_CLOUD.API+ 'Report/AssetValueAmount/?status=' + status + 
                                                  '&type=' + type + 
                                                  '&owner=' + owner + 
                                                  '&site=' + site + 
                                                  '&location=' + location + 
                                                  '&purchaser=' + purchaser + 
                                                  '&start_purchase_date=' + start_purchase_date + 
                                                  '&finish_purchase_date=' + finish_purchase_date +
                                                  '&vendor=' + vendor +
                                                  '&ordering=PurchaseCurrency__Name, Name'
      : params.data.url
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  },
  ReadAsMaster(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API + params.data.query)
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {            
      params.onfailed(error)
      console.log(error);
    });
  },
  DownloadReport(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get( 
      ServerProperties.ATM_CLOUD.API+ 'Report/Asset/?doc_type=' + params.data.doc_type + 
                                                    '&status=' + params.data.status + 
                                                    '&type=' + params.data.type + 
                                                    '&owner='+params.data.owner + 
                                                    '&site=' + params.data.site + 
                                                    '&location=' + params.data.location + 
                                                    '&purchaser=' + params.data.purchaser + 
                                                    '&start_purchase_date=' + params.data.start_purchase_date +
                                                    '&finish_purchase_date=' + params.data.finish_purchase_date + 
                                                    '&vendor=' + params.data.vendor ,
        {
          responseType: 'arraybuffer'
        }, 
        {
          headers: {
            'content-type': 'application/json'
          }
        }
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
        params.onfailed(error)
    });
  }
}


// WEBPACK FOOTER //
// ./src/App/report/model.js